import { Container, Row, Col } from 'react-bootstrap';
import { Styles } from './styles';
import Image from 'next/image';
import HTMLParsedContent from '../HTMLParsedContent';

export type AboutComponentProps = {
  image: string;
  title: string;
  description: string;
  valuesDescription: string;
};

const AboutComponent: React.FC<AboutComponentProps> = ({
  image,
  title,
  description,
  valuesDescription,
}) => {
  return (
    <Styles>
      <section className="about-us">
        <Container>
          <Row>
            <Col lg="6" md="12" style={{ paddingLeft: '0', paddingRight: 0 }}>
              <div className="d-flex justify-content-center about-image mb-sm-5 mb-md-5 mb-lg-0">
                <Image fill src={image} alt="Imagem sobre nós" style={{ objectFit: 'cover' }} />
              </div>
            </Col>
            <Col className="px-sm-0 px-md-0 px-lg-2" lg="6" md="12">
              <div className="about-content">
                <h2 style={{ marginTop: 0 }} className="about-title">
                  {title}
                </h2>
                <HTMLParsedContent className="about-para" content={description} />
              </div>
            </Col>
          </Row>
          {valuesDescription && (
            <Row>
              <div className="about-content">
                <HTMLParsedContent
                  className="about-para"
                  content={valuesDescription.replace(/<li>/g, '<li><i class="la la-check"></i>')}
                />
              </div>
            </Row>
          )}
        </Container>
      </section>
    </Styles>
  );
};

export default AboutComponent;
